import { gql } from "@apollo/client";

export const GET_ME = gql`
  query GetMe {
    me {
      id
      email
      firstName
      lastName
      role
      isEmailVerified
      isManagedSupport
      managedSupportRole
      avatar
      preferences {
        theme
        interfaceLanguage
        notifications {
          email
          push
        }
      }
      twoFactor {
        enabled
        enabledAt
        lastVerifiedAt
        recoveryCodesRemaining
      }
      organizations {
        id
        name
        domain
        logo
        security {
          twoFactorRequired
          twoFactorRequiredRoles
          twoFactorEnforcedAt
          twoFactorEnforcedBy
        }
        members {
          role
          user {
            id
            email
            firstName
            lastName
          }
        }
        settings {
          allowedDomains
          maxChatSessions
          retentionDays
          enableAnalytics
          timezone
          interfaceLanguage
          supportBusinessHours {
            enabled
            days {
              day
              enabled
              slots {
                from
                to
              }
            }
          }
          dailyReportsSettings {
            enabled
            recipients
            mediums
            frequency
            scheduleTime
            whatsappGroupId
            teamsWebhookUrl
          }
          escalatedChatSettings {
            enabled
            idleTimeMinutes
            idleTimeHours
            recipients
            mediums
            whatsappGroupId
            teamsWebhookUrl
          }
          escalatedTicketSettings {
            enabled
            idleTimeMinutes
            idleTimeHours
            recipients
            mediums
            whatsappGroupId
            teamsWebhookUrl
          }
          piiRedaction {
            enabled
            entities
            persistRedactedCopy
          }
          navigation {
            hiddenGroupIds
            pinnedCollections {
              collectionId
              label
            }
          }
        }
        myPermissions
        usage {
          code
          count
          lastUsageAt
        }
        subscription {
          plan
          status
          provider
          billingCycle
          currentPeriodStart
          currentPeriodEnd
          usage {
            code
            count
            limit
            limitExceeded
            lastUsageAt
          }
        }
        billingCurrency
        billingCurrencyForced
        outboundCallingEnabled
        isShopifyManaged
        shopifyBillingRequired
        shopifyShopDomain
      }
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      email
      firstName
      lastName
      role
      isEmailVerified
      avatar
      preferences {
        theme
        interfaceLanguage
        notifications {
          email
          push
        }
      }
      organizations {
        id
        name
        domain
        logo
        members {
          role
          user {
            id
            email
            firstName
            lastName
          }
        }
        settings {
          timezone
          interfaceLanguage
        }
        subscription {
          plan
          status
          billingCycle
          currentPeriodStart
          currentPeriodEnd
          usage {
            code
            count
            limit
            limitExceeded
            lastUsageAt
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id)
  }
`;

export const UPDATE_PASSWORD = gql`
    mutation UpdatePassword($input: UpdatePasswordInput!) {
        updatePassword(input: $input) {
            id
        }
    }
`;

export const AGENT_ACCEPT_INVITATION = gql`
  mutation AgentAcceptInvitation($input: AgentAcceptInvitationInput!) {
    agentAcceptInvitation(input: $input) {
      token
      refreshToken
      user {
        id
        email
        firstName
        lastName
        role
        isEmailVerified
        avatar
        organizations {
          id
          name
          domain
          members {
            role
            user {
              id
              email
              firstName
              lastName
            }
          }
          subscription {
            plan
            status
            billingCycle
            currentPeriodStart
            currentPeriodEnd
            usage {
              code
              count
              limit
              limitExceeded
              lastUsageAt
            }
          }
        }
      }
      expiresIn
    }
  }
`;

